import { render, staticRenderFns } from "./SetName.vue?vue&type=template&id=321b7af4&scoped=true&"
import script from "./SetName.vue?vue&type=script&lang=js&"
export * from "./SetName.vue?vue&type=script&lang=js&"
import style0 from "./SetName.vue?vue&type=style&index=0&id=321b7af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321b7af4",
  null
  
)

export default component.exports